// extracted by mini-css-extract-plugin
export default {"title":"AccountsPayableDetails_title__nZ9Ns","pay":"AccountsPayableDetails_pay__FVXkn"};